import { useWrite } from '@bw/hookshot';
// import configValue from 'utils/config';

type UseSendTNVerification = {
  input: {
    phoneNumber: string;
    email: string;
  };
};

export interface SendTNResponse {
  message: string;
  status: string;
}

export const useSendTNVerification = () => {
  return useWrite<UseSendTNVerification, SendTNResponse>(
    'https://onboarding-service.cx-accounts.lab.us.aws.bandwidth.com/api/lab/express/send',
    'POST',
    {
      requestFormat: 'json',
      fetchOptions: {
        headers: {
          /* eslint-disable-next-line @typescript-eslint/naming-convention */
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      },
    },
  );
};
